// extracted by mini-css-extract-plugin
export default {"root":"HeroImage-root","image":"HeroImage-image"};